import { render } from "./the-cart.vue?vue&type=template&id=0c31f3a2"
import script from "./the-cart.vue?vue&type=script&setup=true&lang=js"
export * from "./the-cart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/shop/cart/the-cart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c31f3a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c31f3a2', __exports__)) {
    api.reload('0c31f3a2', __exports__)
  }
  
  module.hot.accept("./the-cart.vue?vue&type=template&id=0c31f3a2", () => {
    api.rerender('0c31f3a2', render)
  })

}


export default __exports__